import React from 'react';

const SeaLevelRow = ({dayData, units, data}) => {
    // Calculate all heights first (keep negative values for below sea level)
    const heights = dayData.map(({ index }) => {
        const sea_level_height_msl = data?.[index];
        return Math.round(parseFloat(sea_level_height_msl) * 100);
    });

    const maxHeight = Math.max(...heights);
    const minHeight = Math.min(...heights);
    const range = maxHeight - minHeight || 1;

    return (
        <tr className="hover:bg-custom-darker/50 transition-colors relative">
            <td className="pl-2 py-1 text-xs text-custom-light-grey ">
                <div className="inline-flex items-center gap-2 font-medium">
                    <div>
                        <span className="block">Tide</span>
                    </div>
                </div>
            </td>
            <td colSpan={dayData.length} className="relative py-1">
                <div className="relative h-[30px] w-full flex">
                    {/* Individual cells with tide indicators */}
                    {dayData.map((_, i) => {
                        const height = heights[i];
                        const normalizedHeight = ((height - minHeight) / range) * 100;
                        const dotPosition = 100 - normalizedHeight; // Invert for CSS (0 = top, 100 = bottom)
                        
                        return (
                            <div key={i} className="flex-1 relative">
                                {/* Tide dot */}
                                <div 
                                    className="absolute w-1 h-1 bg-blue-400 rounded-full transform -translate-x-1/2 -translate-y-1/2 shadow-sm"
                                    style={{ 
                                        left: '50%', 
                                        top: `${dotPosition}%` 
                                    }}
                                />
                                {/* Connection line to next dot */}
                                {i < dayData.length - 1 && (
                                    <div className="absolute top-0 left-1/2 w-full h-full overflow-hidden">
                                        <svg 
                                            className="absolute top-0 left-0 w-full h-full"
                                            preserveAspectRatio="none"
                                            viewBox="0 0 100 100"
                                        >
                                            <line
                                                x1="0"
                                                y1={dotPosition}
                                                x2="100"
                                                y2={100 - ((heights[i + 1] - minHeight) / range) * 100}
                                                stroke="#60a5fa"
                                                strokeWidth="1"
                                                vectorEffect="non-scaling-stroke"
                                            />
                                        </svg>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </td>
        </tr>
    )
}

export default SeaLevelRow;